import React from 'react';
import { NotificationDialog } from 'Components';

export default props => {
  return (
    <NotificationDialog
      {...props}
      title={'Emancipated Minor Warning'}
      message={
        "Please note that marking a student as 'Emancipated Minor' will also set them as Head of Household."
      }
    />
  );
};



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/student/EmancipatedMinorWarningDialog.js